'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Textarea(props) {
  var isInvalid = props.isInvalid,
      _props$rows = props.rows,
      rows = _props$rows === undefined ? 3 : _props$rows,
      inputRef = props.inputRef,
      passing = _objectWithoutProperties(props, ['isInvalid', 'rows', 'inputRef']);

  return _react2.default.createElement('textarea', _extends({
    ref: inputRef,
    style: isInvalid ? { borderColor: 'red' } : null,
    className: isInvalid ? 'form-control is-invalid' : 'form-control',
    rows: rows
  }, passing));
}

Textarea.propTypes = {
  rows: _propTypes.number,
  inputRef: _propTypes.func,
  isInvalid: _propTypes.bool
};

exports.default = Textarea;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Textarea/Textarea.js
// module id = 1727
// module chunks = 0